import React from 'react';
import { Paragraph } from "../../../typography/Paragraph";
import { buildKeyFromStrings } from "../../../../utils/build-key-from-strings";
import { GridColumn } from "../../../layout/GridColumn";
import { Icon } from "../../../elements/Icon";
import { getFormattedAmenityItems } from "./getFormattedAmenityItems";
export var getCategoryMarkup = function getCategoryMarkup(category, index, amenitiesConjunctionText) {
  return React.createElement(GridColumn, {
    key: buildKeyFromStrings(category.name, index)
  }, React.createElement(Icon, {
    isLabelLeft: true,
    labelText: category.name,
    labelWeight: "heavy",
    name: category.iconName
  }), React.createElement(Paragraph, null, getFormattedAmenityItems(category.items, amenitiesConjunctionText)));
};